<template>
  <div v-if="customer && customer.uuid" class="row">
    <div class="col-12">
      <br>
      <label>Assigned streams</label>
      <vue-tags-input
        v-model="tag"
        class="streamsvueinput"
        :tags="tags"
        :autocomplete-items="filteredItems"
        :add-only-from-autocomplete="true"
        :avoid-adding-duplicates="true"
        placeholder="assign stream..."
        @tags-changed="updateCustomerStreams" />
    </div>
  </div>
</template>

<script>
import { VueTagsInput, createTags } from "@johmun/vue-tags-input";

export default {
  components: {
    VueTagsInput,
  },
  model: {
    prop: 'customerStreams',
    event: 'input',
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    globalStreams: {
      type: Array,
      required: true,
    },
    customerStreams: {
      type: null,
      default: null,
    },
  },
  data: () => ({
    tag: "",
    tags: [],
  }),
  computed: {
    filteredItems() {
      return createTags(_.map(this.globalStreams, "name")).filter(i =>
        new RegExp(this.tag, "i").test(i.text),
      );
    },
  },
  watch: {
    customerStreams: {
      deep: true,
      handler: function (new_val) {
        this.tags = createTags(_.map(new_val, "name"));
      },
    },
  },
  methods: {
    updateCustomerStreams(new_tags) {
      const selected_streams = this.globalStreams.filter(stream => new_tags.map(tag => tag.text).includes(stream.name));
      this.$emit('input', selected_streams);
    },
  },
};
</script>

<style lang="scss">
.streamsvueinput.vue-tags-input {
    max-width: none;
    width: 100%;
    margin: 5px 0;
}
</style>
